export default "__VITE_ASSET__CMlhJr8k__"